import React from "react";
import { motion } from "framer-motion";
import backautor from "../../backautor.jpg";
import Rosty from "../../Rosty.jpg";

const ArtistSection = () => {
  return (
    <section id="artist" className="py-20 bg-primary-dark">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, margin: "-100px" }}
          >
            <div className="relative">
              <motion.div
                className="w-full h-96 md:h-[600px] rounded-2xl overflow-hidden"
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.5 }}
              >
                <img
                  src={backautor}
                  alt="El Artista"
                  className="w-full h-full object-cover"
                />
              </motion.div>
              <motion.div
                className="absolute -bottom-10 -right-10 w-48 h-48 rounded-xl overflow-hidden border-4 border-primary-dark shadow-xl"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <img
                  src={Rosty}
                  alt="Trabajando en el estudio"
                  className="w-full h-full object-cover"
                />
              </motion.div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, margin: "-100px" }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-8 text-accent-light">
              SOBRE EL AUTOR
            </h2>
            <h3 className="text-2xl md:text-3xl font-semibold mb-6 text-accent-light">
              Rosalba Olivieri
            </h3>
            <div className="space-y-6 text-accent-light text-opacity-90">
              <p>
                Imaginar es parte importante de mi personalidad. La creatividad
                me lleva de viaje sin permiso, creo que habito más ahí que en lo
                cotidiano. En mi mundo, lo diferente no es malo, lo bonito no le
                gusta a todos y en lo oscuro hay luz. Soy lenta, pero tan lenta,
                que por eso observo más. Me quedo absorta en los detalles, a tal
                grado, que me pierdo en el camino.
              </p>
              <p>
                Dibujar, pintar, esculpir, grabar, escribir, decorar, bailar,
                cantar, son actividades de uso diario.
              </p>
              <p>
                Cuando escribo o dibujo, se sienta a mi lado derecho la
                creatividad descarada, y a mi lado izquierdo se acomoda la duda.
                Yo, quedo en el medio en una verdadera guerra, pero disfruto
                enormemente habitar en esa trinchera. La creatividad es una
                forma de operar y ahí soy muy feliz.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ArtistSection;
